import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'
import { bankOptionsOrdianry, bankOptionsATM } from '../components/bank-options'

export const _paymentChannelsSubSection = (bankOptionsSection, bankData, basicPlan) => [
  { text: MESSAGES.PAYMENT_TERM_ORDINARY },
  {
    ol: [
      {
        text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_1_NO_AGENT,
      },
      { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_2 },
      {
        stack: [
          {
            text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_3_NO_SPECIAL,
          },
          { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_3_SUB_TITLE },
          bankOptionsSection,
        ],
      },
      {
        stack: [{ text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_4 }, bankData],
      },
      { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_5 },
      { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_6 },
      { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_7 },
      { text: MESSAGES.PAYMENT_CHANNEL_ORDINARY_8 },
    ],
  },
]

export const paymentChannelsSubSectionOrdinary = async (basicPlan) => {
  const bankOptionsSection = await bankOptionsOrdianry()
  const bankData = await bankOptionsATM(basicPlan)
  return _paymentChannelsSubSection(bankOptionsSection, bankData, basicPlan)
}
